import { render, staticRenderFns } from "./LicenseModal.vue?vue&type=template&id=06ca5a46&scoped=true&"
import script from "./LicenseModal.vue?vue&type=script&lang=js&"
export * from "./LicenseModal.vue?vue&type=script&lang=js&"
import style0 from "./LicenseModal.vue?vue&type=style&index=0&id=06ca5a46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca5a46",
  null
  
)

export default component.exports